<template>
  <modal
    :show.sync="isModalOpenLocal"
    header-classes="bg-primary cust-whiteclose p-3"
    block
  >
    <h6
      slot="header"
      class="modal-title text-white modal-close-btn font-semibold pt-1"
    >
      Edit Channel
    </h6>
    <div class="selectcard-hover items-center mb-3">
      <label for="chnlname" class="form-control-label">Channel Name</label>
      <b-input
        id="chnlname"
        @change="(text) => (name = text)"
        :value="name"
        placeholder="Enter Community Name..."
        class="form-control-muted"
      />
    </div>
    <div class="mb-4">
      <base-input label="Channel Description">
        <textarea
          @change="(e) => (description = e.target.value)"
          :value="description"
          placeholder="Enter Channel Description..."
          class="form-control form-control-muted"
          id="channel-description"
          rows="3"
        ></textarea>
      </base-input>
    </div>
    <div class="selectcard-hover items-center mb-3">
      <label for="chnlprice" class="form-control-label">Price</label>
      <b-input
        id="chnlprice"
        @change="(text) => (price = text)"
        :value="price"
        placeholder="Enter Price..."
        class="form-control-muted"
      />
    </div>
    <div class="mb-0">
      <div class="flex w-full items-center">
        <label for="chnlimg" class="form-control-label mr-8"
          >Profile Picture</label
        >
        <!-- <feather-icon
          icon="UploadCloudIcon"
          class="cursor-pointer mb-1.5"
          svgClasses="w-5"
        ></feather-icon> -->
      </div>
      <div class="relative">
        <FileUploader :onSuccess="loadImage" v-if="!SelectedImage" />
        <div class="border rounded-t-md">
          <img
            v-if="SelectedImage"
            :src="renderedImage || SelectedImage"
            id="chnlimg"
            alt="channel profile picture"
            class="flex mx-auto rounded-md max-ht-15rem-res"
          />
        </div>
        <div
          v-if="SelectedImage"
          class="text-center cust-bgededed p-1 rounded-b-md"
          @click="SelectedImage = ''"
        >
          <b-button variant="danger" class="px-4 py-1">Remove</b-button>
        </div>
      </div>
      <!-- <FileUploader /> -->
    </div>
    <template slot="footer">
      <base-button type="primary" @click.stop="handleSubmit"
        >SUBMIT</base-button
      >
    </template>
  </modal>
</template>

<script>
import FileUploader from "@/components/FileUploader.vue";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isModalOpen(val) {
      if (val) {
        this.name = this.channel.name;
        this.price = this.channel.price;
        this.description = this.channel.description;
        this.SelectedImage = this.channelImage();
      }
    },
  },
  computed: {
    isModalOpenLocal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        if (!val) {
          this.$emit("close-modal");
        }
      },
    },
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
  },
  data() {
    return {
      name: "",
      price: "",
      description: "",
      SelectedImage: "",
      renderedImage: "",
      cropperImg: "",
    };
  },
  methods: {
    async handleSubmit() {
      // const payload = {
      //   channelID: this.channel._id,
      //   name: this.name,
      //   description: this.description,
      // };

      const payload = new FormData();
      payload.append("channelID", this.channel._id);
      payload.append("name", this.name);
      payload.append("price", this.price);
      payload.append("description", this.description);
      if (!/google/gi.test(this.SelectedImage)) {
        payload.append("media", this.SelectedImage);
      }

      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/editChannel", payload);
        loader.close();
        this.$store.dispatch("channel/GetALLChannel");
        this.isModalOpenLocal = false;
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    channelImage() {
      return `${this.$imageURL}/${this.channel.picture}`;
    },
    loadImage(image) {
      this.SelectedImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
  },
};
</script>
